<template>
    <div>
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
            v-loading="dataLoading"
        >
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="avatar" label="头像:">
                        <avatar 
                            :url.sync="formData.avatar" 
                            :urlFull.sync="formData.avatarFull" 
                            :crop="true"
                            :width="800"
                            :height="800"
                        >
                            <span slot="size">建议尺寸为800*800px</span>
                        </avatar>
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="姓名:">
                        <el-input
                            v-model="formData.name"
                            placeholder="请输入姓名"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="telephone" label="手机:">
                        <el-input
                            v-model="formData.telephone"
                            placeholder="请输入手机号"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :xl="16">
                    <el-form-item prop="activityList" label="演出:">
                        <el-input v-model="queryId" class="input-with-select" placeholder="请输入演出ID" size="medium">
                            <el-select
                                v-model="queryType"
                                slot="prepend"
                                placeholder="请选择"
                            >
                                <el-option label="许可演出" :value="1"></el-option>
                                <el-option label="许可巡演" :value="2"></el-option>
                            </el-select>
                            <el-button slot="append" icon="el-icon-circle-plus" @click="searchEvent">添加</el-button>
                        </el-input>
                        <small class="from-tip"><span class="el-icon-warning"></span> 通过ID查询并绑定相关演出</small>
                        <!-- <div class="add-btn" @click="add"><i class="el-icon-plus"></i> 新增演出</div> -->
                        <el-table
                            v-if="activityList && activityList.length > 0"
                            :data="activityList"
                            border
                            style="width: 100%"
                            size="small"
                        >
                            <el-table-column prop="activityId" label="演出ID"></el-table-column>
                            <el-table-column prop="activityTitle" label="演出名称"></el-table-column>
                            <el-table-column label="有效期" min-width="130">
                                <template slot-scope="scope">
                                    <el-date-picker
                                        v-model="scope.row.datetimerange"
                                        type="datetimerange"
                                        start-placeholder="有效开始时间"
                                        end-placeholder="有效结束时间"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        size="small"
                                        unlink-panels
                                    >
                                    </el-date-picker>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        size="small"
                                        icon="el-icon-delete"
                                        @click="del(scope.row.activityId)"
                                        >删除</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :xl="16">
                    <el-form-item prop="remarks" label="备注:">
                        <el-input
                            v-model="formData.remarks"
                            type="textarea"
                            placeholder="请输入备注"
                            show-word-limit
                            maxlength="100"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button @click="goBack">返回取消</el-button>
                <el-button
                    type="primary"
                    @click="submitForm"
                    :loading="btnLoading"
                    >确认提交</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Avatar from '@/components/ImageUpload'
const defaultFormData = {
    name:"",
    telephone: "",
    avatar:"",
    // avatar:"",
    activityList:[],
    remarks:''
}
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components:{Avatar},
    data() {
        return {
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                name:[{required: true, message: "请输入姓名"}],
                telephone: [
                    { required: true, message: "请输入手机号码" },
                    { validator: this.$utils.validatePhone }
                ],
                activityList:[{type: 'array', required: true, message: "请选择许可演出或巡演"}],
            },
            redirect: this.$route.query.redirect || "/user/userPermit/list",
            activityList:[],
            queryType:1,
            queryId:''
        };
    },
    created(){
        if (this.id) {
            this.getDataDetail();
        }
    },
    methods: {
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/userPermit/detail",
                data: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = {
                            ...result
                        };
                        this.activityList = result.activityList || [];
                        this.activityList.map( item => {
                            const _arry = [item.startTime || '',item.endTime || '']
                            this.$set(item,'datetimerange',_arry);
                        })
                    } else {
                        self.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //搜索演出事件
        searchEvent() {
            if (this.queryId !== "") {
                this.dataLoading = true;
                this.$request({
                    url: "/userPermit/queryActivity",
                    data: { queryId: this.queryId,queryType:this.queryType },
                    method: "post",
                })
                    .then((res) => {
                        const { state, result, msg } = res.data;
                        if (state == 1 && result.length > 0) {
                            result.map(item => {
                                const _obj = this.activityList.find(v => v.activityId === item.activityId)
                                if( !_obj ){
                                    const _arry = [item.startTime || '',item.endTime || '']
                                    this.$set(item,'datetimerange',_arry);
                                    this.activityList.push(item) ;
                                    this.queryId = '';
                                    this.formData.activityList = [...this.activityList];
                                }
                                
                            })
                            
                        }else{
                            this.$message.error(msg || '没有找到相关演出');
                        }
                    }).catch(() => {
                        this.$message.error('系统错误');
                    }).finally(() => {
                        this.dataLoading = false;
                    });
            }
        },
        //删除演出
        del(id){
            const _msg = '确定要删除吗?';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.activityList = this.activityList.filter( item => item.activityId !== id);
                this.formData.activityList = [...this.activityList];
            }).catch(() => {})
        },
        //表单提交
        submitForm() {
            let self = this;
            
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    
                    const _url = this.id
                        ? "/userPermit/edit"
                        : "/userPermit/add";
                    this.btnLoading = true;

                    this.activityList.map(item => {
                        item.startTime = item.datetimerange ? item.datetimerange[0] : '';
                        item.endTime = item.datetimerange ? item.datetimerange[1] : '';
                    })

                    this.formData.activityList = [...this.activityList];

                    this.$request({
                        url: _url,
                        data: this.formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                self.goBack()
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        //返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        } 
    },
};
</script>


